import React, { useContext } from 'react'
import { DefaultDParams } from '../../../app/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { MonthlyClosureDetailDataForm } from '../../../app/models/MonthlyClosureDetail';
import useMonthlyClosureDetailWorkerService from '../../../app/services/hooks/useMonthlyClosureDetailWorkerService';

interface Props {
    detail: MonthlyClosureDetailDataForm;
    statuses: DefaultDParams[];
    callbackSuccess?: () => void;
}

const MonthlyClosureDetailWorkerStatusChange = ({
    detail,
    statuses,
    callbackSuccess,
}: Props) => {

    const { showLoading, hideLoading } = useContext(AppContext);
    const {  
        changeMonthlyClosureDetailWorkerStatus,
    } = useMonthlyClosureDetailWorkerService();

    const changeStatus = (status: string, detailId: number | undefined) => {
        if(!detailId) return null
        if (showLoading) showLoading('loading', 'cargando..');

        changeMonthlyClosureDetailWorkerStatus(detailId, status, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                if(callbackSuccess) callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };


    
    return (
        <select
            className="form-control"
            value={detail.status_obj?.id}
            onChange={(e) => changeStatus(e.target.value, detail.id)}
        >
            {statuses
                .map((status) => {
                    detail.status_obj?.id !== status.id
                    return (
                        <option key={status.id} value={status.id}>
                            {status.name}
                        </option>
                    );
                })}
        </select>
    )
}

export default MonthlyClosureDetailWorkerStatusChange
